import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

type Crumb = { label: string; to?: string };

type Props = {
  title: ReactNode;
  subtitle?: ReactNode;
  breadcrumbs?: Crumb[];
  actions?: ReactNode;
};

export function PageHeader({ title, subtitle, breadcrumbs, actions }: Props) {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 sm:gap-4 mb-5 sm:mb-6">
      <div className="min-w-0">
        <h1 className="text-xl sm:text-[1.5rem] font-bold text-[#181c32] leading-tight">{title}</h1>
        {(subtitle || breadcrumbs?.length) && (
          <div className="breadcrumb mt-1.5 flex-wrap">
            <Link to="/" className="hover:text-brand-600 inline-flex items-center">
              <Home size={12} />
            </Link>
            {breadcrumbs?.map((c, i) => (
              <span key={i} className="inline-flex items-center gap-1.5">
                <ChevronRight size={12} className="text-[#b5b5c3]" />
                {c.to ? (
                  <Link to={c.to} className="hover:text-brand-600">
                    {c.label}
                  </Link>
                ) : (
                  <span className="text-[#3f4254]">{c.label}</span>
                )}
              </span>
            ))}
            {subtitle && !breadcrumbs?.length && <span className="text-[#3f4254]">{subtitle}</span>}
          </div>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap md:shrink-0">{actions}</div>}
    </div>
  );
}
